// export const base = "http://132.226.206.68/vaswrapper";
export const base = "https://proxy.v2napi.com";
